export class AnytimeAccessPatronLoginAttemptsReportRowDto
{
    subjectId : string;
    deviceName: string;
    timestampUtc: string;
    dayOfWeek: string;
    datestampUtc: string;
    success : string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/reports/anytime-access/anytime-access-patron-login-attempts-report-row.dto.ts